import { Link } from "gatsby"
import React from "react"
import { useAppDispatch } from "../../state/hooks"
import { toggleMobile } from "../../state/menus"
import { CartButton } from "./CartButton"
import ContactButton from "./ContactButton"
import { StaticImage } from "gatsby-plugin-image"

export function Header() {
  const dispatch = useAppDispatch()

  return (
    <div className="fixed z-50 w-full bg-black site-header md:border-b md:border-white ">
      <div className="grid items-center justify-between grid-cols-5 px-2 md:flex md:px-0">
        <button
          onClick={() => dispatch(toggleMobile())}
          className="h-full text-left uppercase md:hidden"
        >
          Menu
        </button>

        <Link
          to={"/"}
          className="col-span-3 text-center md:ml-3 md:text-left whitespace-nowrap"
        >
          UNIFORM OBJECT
        </Link>

        <div className="flex items-center h-full grid-cols-2 my-2 header-right md:grid justify-self-end md:justify-self-start md:gap-2 md:mr-2 md:grid-cols-5 justify-items-center">
          <StaticImage
            className="hidden object-contain w-10 h-10 md:block"
            src="../../img/uf-icon-white.png"
            alt="uf icon white base"
          />

          <Link
            className="hidden md:block"
            to="https://uniform-object.myshopify.com/account/login"
          >
            ACCOUNT
          </Link>

          <ContactButton visible={false} />

          <img
            className="hidden object-contain w-8 h-10 sm:block"
            src="/gif/diamond-gif.gif"
            alt="GIF of a spinning diamond"
          />

          <CartButton />
        </div>
      </div>
    </div>
  )
}
